module.exports = __webpack_public_path__ + "img/zhesyh.42b2c69d.png";